import { createSelector } from '@opengov/compose-app/reselect';
import { processNamespace } from '@opengov/locale/namespaces';
import { LocaleText, report } from '../../../src/locale';
import { ILocaleFormatter } from '../../../src/locale/types';

export const reportLocaleText = processNamespace({ report }).report;

// TODO: [REP-8818] replace all instances of IReportLocale with LocaleText
export { report } from '../../../src/locale';
export type IReportLocale = LocaleText;

export const selectLocaleFormatter = createSelector(
  reportLocaleText,
  (localeText): ILocaleFormatter => ({
    percent: localeText.reportTable.percentFormat,
    number: localeText.reportTable.numberFormat,
    date: localeText.reportTable.dateFormat,
    currency: localeText.reportTable.usdFormat
  })
);

export const selectLocalePercentFormat = createSelector(selectLocaleFormatter, (formatter) => formatter.percent);

export const selectReportExplorerMsgs = createSelector(reportLocaleText, (txt) => txt.reportExplorer);

export * from '../../../src/locale/types';
export * from './util';
